import { useState } from 'react'
import { ChangePasswordForm } from './ChangePasswordForm'
import { makePostRequest, loginRedirect } from 'utils/api'
import queryString from 'query-string'
import { authenticate, getTenant } from 'utils/authService'
import { useNavigate } from 'react-router-dom'

const ChangePasswordContainer = () => {
  const { token } = queryString.parse(window.location.search)
  const [isError, setIsError] = useState(false)
  const navigate = useNavigate()

  const formSubmit = async values => {
    try {
      const newToken = await makePostRequest(
        '/v1/users/confirm-reset',
        {
          token,
          password: values.password
        },
        {
          headers: {
            'x-tenant-schema': getTenant(token)
          }
        }
      )
      authenticate(newToken)
      loginRedirect(navigate, newToken)
    } catch (e) {
      setIsError(true)
    }
  }
  return <ChangePasswordForm isError={isError} formSubmit={formSubmit} />
}

export default ChangePasswordContainer
